import styled from 'styled-components';

import { media } from '@/styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: auto;
  width: 100%;

  ${media.phone} {
    width: calc(50% - 14px);
    min-width: 400px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;

  h4 {
    font-size: 16px;
    font-weight: 400;
    color: #0a4599;
    margin: 0 0 0 14px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  img {
    height: 17px;
  }
`;

export const ButtonPreview = styled.img`
  height: 12px;
  width: 100%;
  cursor: pointer;
`;
